import axios from "axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const cleanedBackendUrl = backendUrl.replace("/backend", "");

const DiscountService = {
  getListDiscount(page, perPage, code) {
    return axios.get(
      `${cleanedBackendUrl}/discount`,
      {
        params: {
          page: page,
          perPage: perPage,
          code: code
        }
      }
    )
  },
  addDiscount(
    discountCode,
    discountType,
    discountAmount,
    discountStart,
    discountEnd,
    description,
    minSpend,
    maxDiscount
  ) {
    return axios.post(
      `${cleanedBackendUrl}/discount`,
      {
        discountCode: discountCode,
        discountType: discountType,
        discountAmount: discountAmount,
        discountStart: discountStart,
        discountEnd: discountEnd,
        description: description,
        minSpend: minSpend,
        maxDiscount: maxDiscount
      }
    );
  },
  updateDiscount(
    id,
    discountType,
    discountAmount,
    discountStart,
    discountEnd,
    description,
    minSpend,
    maxDiscount
  ) {
    return axios.put(
      `${cleanedBackendUrl}/discount/${id}`,
      {
        discountType: discountType,
        discountAmount: discountAmount,
        discountStart: discountStart,
        discountEnd: discountEnd,
        description: description,
        minSpend: minSpend,
        maxDiscount: maxDiscount
      }
    );
  },
  deleteDiscount(id) {
    return axios.delete(`${cleanedBackendUrl}/discount/${id}`);
  }
};

export default DiscountService;